<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <loading-overlay v-model:active="isLoading" :is-full-page="true" />
  <div v-if="isInitError" id="com_form_contet_admin">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-else class="com_form_contet_admin">
    <section class="com_sec1">
      <div class="inner1">
        <h2 class="title_left">申請状況一覧</h2>
      </div>
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </section>
    <!-- 検索条件1行目 -->
    <div class="">
      <table style="width: 100%">
        <th style="width: 8%"></th>
        <th style="width: 13%"></th>
        <th style="width: 3%"></th>
        <th style="width: 13%"></th>
        <th style="width: 10%"></th>
        <th style="width: 15%"></th>
        <th style="width: 10%"></th>
        <th style="width: 15%"></th>
        <th style="width: 10%"></th>
        <tbody>
          <tr>
            <td class="form-control-title">
              <label class="required-mark">※</label>申請期間
            </td>
            <td>
              <input
                type="date"
                v-model="appSearchCond.appDateFrom"
                :max="AppConstants.MAX_DATE_VALUE"
                class="form-control"
              />
            </td>
            <td class="form-control-center">~</td>
            <td>
              <input
                type="date"
                v-model="appSearchCond.appDateTo"
                :max="AppConstants.MAX_DATE_VALUE"
                class="form-control"
              />
            </td>
            <td class="form-control-title">申請種別</td>
            <td>
              <select v-model="appSearchCond.appType" class="form-control">
                <option value=""></option>
                <option
                  v-for="item in appCategoryList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.text }}
                </option>
              </select>
            </td>
            <td class="form-control-title">ステータス</td>
            <td>
              <select v-model="appSearchCond.status" class="form-control">
                <option value=""></option>
                <option
                  v-for="item in statusList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.text }}
                </option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 検索条件２行目 -->
      <table style="width: 100%">
        <th style="width: 8%"></th>
        <th style="width: 13%"></th>
        <th style="width: 3%"></th>
        <th style="width: 13%"></th>
        <th style="width: 10%"></th>
        <th style="width: 15%"></th>
        <th style="width: 3%"></th>
        <th style="width: 18%"></th>
        <th style="width: 14%"></th>
        <tbody>
          <tr>
            <td class="form-control-title">キーワード</td>
            <td colspan="3">
              <input
                v-model="appSearchCond.keyword"
                type="text"
                placeholder="申請タイトルと申請内容を検索します"
                maxlength="50"
                class="form-control"
              />
            </td>
            <td class="form-control-title">希望納期</td>
            <td>
              <input
                type="date"
                v-model="appSearchCond.wishDate"
                :max="AppConstants.MAX_DATE_VALUE"
                class="form-control"
              />
            </td>
            <td>まで</td>
            <td class="form-control-title">完了しているものを除く</td>
            <td>
              <input
                type="checkbox"
                class="form-check-input"
                v-model="appSearchCond.disableFinised"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 検索条件３行目 -->
      <table style="width: 100%">
        <th style="width: 8%"></th>
        <th style="width: 16%"></th>
        <th style="width: 13%"></th>
        <th style="width: 10%"></th>
        <th style="width: 15%"></th>
        <th style="width: 10%"></th>
        <th style="width: 15%"></th>
        <th style="width: 10%"></th>
        <tbody>
          <tr>
            <td class="form-control-title">エージェント</td>
            <td colspan="2">
              <select v-model="appSearchCond.agCode" class="form-control">
                <option value=""></option>
                <option
                  v-for="item in agCodeDataList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.value + " " + item.text }}
                </option>
              </select>
            </td>
            <td class="form-control-title">対応担当者</td>
            <td>
              <input
                v-model="appSearchCond.operater"
                type="text"
                maxlength="20"
                class="form-control"
              />
            </td>
            <td class="form-control-title">営業担当者</td>
            <td>
              <input
                v-model="appSearchCond.kaunetUser"
                type="text"
                maxlength="20"
                class="form-control"
              />
            </td>
            <td class="form-control-title">
              <button
                type="button"
                name="btnSearch"
                class="btn btn-primary"
                @click="onSearch"
              >
                検索
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <hr />
    <!-- 検索結果 -->
    <div class="header">
      <div>
        <h4>申請履歴</h4>
      </div>
      <!-- 右側：表示件数のリンク -->
      <div class="page-size-selector">
        <span>表示件数 </span>
        <template v-for="(size, index) in dispNums" :key="size">
          <a
            href="#"
            @click.prevent="changePageSize(size)"
            :class="{ active: itemsPerPage === size, disabled: isSearchMode }"
          >
            {{ size }}件
          </a>
          <span v-if="index < dispNums.length - 1"> | </span>
        </template>
      </div>
    </div>

    <div class="">
      <label class="" v-if="!isSearchMode">件数：</label>
      <label class="" v-if="!isSearchMode">
        {{ appDataList.length.toLocaleString() }} 件
      </label>
      <table class="table table-bordered" style="font-size: 11.5px">
        <thead class="thead-light">
          <tr>
            <th class="col_btnUpdate">編集</th>
            <th
              :class="[
                'col_SinseiNo',
                'sortable',
                isDirectionASC('shinseiNo') ? 'asc' : 'desc',
              ]"
              @click="onSortItem('shinseiNo')"
            >
              申請No.
            </th>
            <th
              :class="[
                'col_SinseiDate',
                'sortable',
                isDirectionASC('shinseiDate') ? 'asc' : 'desc',
              ]"
              @click="onSortItem('shinseiDate')"
            >
              申請日
            </th>
            <th class="col_SinseiUser">申請者</th>
            <th
              :class="[
                'col_SinseiCategiry',
                'sortable',
                isDirectionASC('shinseiCategory') ? 'asc' : 'desc',
              ]"
              @click="onSortItem('shinseiCategory')"
            >
              申請種別
            </th>
            <th class="col_SinseiTitle">申請タイトル</th>
            <th
              :class="[
                'col_SinseiStatus',
                'sortable',
                isDirectionASC('shinseiStatus') ? 'asc' : 'desc',
              ]"
              @click="onSortItem('shinseiStatus')"
            >
              ステータス
            </th>
            <th
              :class="[
                'col_WishDate',
                'sortable',
                isDirectionASC('wishDate') ? 'asc' : 'desc',
              ]"
              @click="onSortItem('wishDate')"
            >
              希望納期
            </th>
            <th
              :class="[
                'col_LastUpdate',
                'sortable',
                isDirectionASC('lastUpdate') ? 'asc' : 'desc',
              ]"
              @click="onSortItem('lastUpdate')"
            >
              最終更新日
            </th>
            <th class="col_Operater">対応<br />担当者</th>
            <th class="col_KaunetUser">営業<br />担当者</th>
            <th
              :class="[
                'col_AgCode',
                'sortable',
                isDirectionASC('agCode') ? 'asc' : 'desc',
              ]"
              @click="onSortItem('agCode')"
            >
              申請<br />AGコード
            </th>
            <th class="col_AgName">申請<br />AG名称</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in paginatedData" :key="item.applicationNo">
            <td data-name="mBtnUpdate" style="text-align: center">
              <button
                type="button"
                name="mBtnUpdate"
                class="btn btn-primary btn-sm"
                @click="onEdit(item.applicationNo)"
              >
                編集
              </button>
            </td>
            <td data-name="mShinseiNo" class="form-control-center">
              {{ item.applicationNo }}
            </td>
            <td data-name="mShinseiDate" class="form-control-center">
              {{ item.applicationDate }}
            </td>
            <td data-name="mShinseiUser">
              <span class="ellipsis-label" v-tooltip="item.applicationUser">{{
                item.applicationUser
              }}</span>
            </td>
            <td
              data-name="mShinseiCategory"
              v-tooltip="item.applicationCategoryName"
            >
              {{ item.applicationCategoryName }}
            </td>
            <td data-name="mShinseiTitle">
              <span
                class="ellipsis-link"
                v-tooltip="item.applicationTitle"
                @click="onEdit(item.applicationNo, true)"
                >{{ item.applicationTitle }}</span
              >
              <span v-if="item.kaunetNewFlg" class="com_icon_new_app">
                NEW</span
              >
            </td>
            <td data-name="mShinseiStatus" v-tooltip="item.statusName">
              {{ item.statusName }}
            </td>
            <td data-name="mWishDate" class="form-control-center">
              {{ item.wishDate }}
            </td>
            <td data-name="mLastUpdate" class="form-control-center">
              {{ item.lastUpdDate }}
            </td>
            <td>
              <span v-tooltip="item.operater">{{ item.operater }}</span>
            </td>
            <td>
              <span v-tooltip="item.kaunetUser">{{ item.kaunetUser }}</span>
            </td>
            <td>
              <span>{{ item.appAgCode }}</span>
            </td>
            <td>
              <span v-tooltip="item.appAgName">{{ item.appAgName }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <content-pagination
        :current-page="currentPage"
        :total-pages="totalPages"
        :items-per-page="itemsPerPage"
        @page-changed="handlePageChange"
      />
    </div>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
</template>

<script lang="ts">
import { AxiosError } from "axios";
import { defineComponent, onMounted, ref, computed } from "vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import ContentPagination from "../controls/ContentPagination.vue";
import {
  formatMessage,
  outputDebugLogs,
  scrollToTop,
  isTokenAlive,
  commonHandleAxiosError,
  formatDate,
  sanitizeInput,
  trimKeyword,
} from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import apiAuthClient from "@/util/apiClientAuth";
import { useProcessingStore } from "../../store/useProcessingStore";
import messages from "@/assets/messages.json";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";
import { useRouter } from "vue-router";
import LoadingOverlay from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

/**
 * 申請情報
 */
interface applicationData {
  selection: boolean;
  applicationNo: string;
  applicationDate: string;
  applicationUser: string;
  applicationCategoryId: string;
  applicationCategoryName: string;
  applicationTitle: string;
  kaunetNewFlg: boolean;
  statusKbn: string;
  statusName: string;
  wishDate: string;
  lastUpdDate: string;
  operater: string;
  kaunetUser: string;
  appAgCode: string;
  appAgName: string;
}

/**
 * 申請情報検索条件
 */
interface appSearchCond {
  appDateFrom: string;
  appDateTo: string;
  appType: string;
  status: string;
  keyword: string;
  wishDate: string;
  disableFinised: boolean;
  agCode: string;
  operater: string;
  kaunetUser: string;
}

interface selectItem {
  value: string;
  text: string;
}

interface sortItem {
  key: string;
  direction: string;
}

interface appMgtParam {
  appSearchCond: appSearchCond;
  itemsPerPage: number;
  currentPage: number;
  processingMode: string;
}

class ApplicationListConstants {
  // ソート種別
  static readonly SORT_TYPE_ASC = "ASC"; // 昇順
  static readonly SORT_TYPE_DESC = "DESC"; // 降順
}

export default defineComponent({
  name: "ApplicationMGListKaunetComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    BackToTop,
    ContentPagination,
    LoadingOverlay,
  },
  setup() {
    const router = useRouter();
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const processingStore = useProcessingStore();
    const { logoutUser } = useUserStore();
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const errorMessage = ref(""); // エラーメッセージ（キーワード検索の下のやつ）
    const agCode = ref(""); // AGコード
    const userId = ref(""); // ユーザーID
    const pseudoAgCode = ref(""); // 疑似ログインAGコード
    const pseudoUserId = ref(""); // 疑似ログインユーザーID
    const pseudoDaihyoCode = ref(""); // 疑似ログイン代表コード
    const serchAgCode = ref(""); // 検索用AGコード
    const serchUserId = ref(""); // 検索用ユーザーID
    const serchDaihyoCode = ref(""); // 検索用代表コード
    const daihyoCode = ref(""); // 代表コード
    const isAdmin = ref(false); // 管理者フラグ
    const processingMode = ref("");
    const isLoading = ref(false);
    const currentPage = ref(1); // 現在ページ
    const itemsPerPage = ref(20); // 1ページに表示する最大件数
    const appDataList = ref<applicationData[]>([]);
    const appDataSortItemList = ref<sortItem[]>([]);
    const appCategoryList = ref<selectItem[]>([]);
    const statusList = ref<selectItem[]>([]);
    const agCodeDataList = ref<selectItem[]>([]);
    const userList = ref<selectItem[]>([]);
    const dispNums = [20, 50, 100];
    const appSearchCond = ref<appSearchCond>({
      appDateFrom: "",
      appDateTo: "",
      appType: "",
      status: "",
      keyword: "",
      wishDate: "",
      disableFinised: false,
      agCode: "",
      operater: "",
      kaunetUser: "",
    });
    /**
     * 検索条件入力モード判定
     */
    const isSearchMode = computed(() => {
      return processingMode.value == AppConstants.PROCESSING_MODE_SERACH;
    });

    // 初期処理
    onMounted(async () => {
      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;

      try {
        // 初期処理時はTrue
        isInitError.value = true;

        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
          pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
          pseudoUserId.value = parsedUserInfo.pseudoUserId;
          pseudoDaihyoCode.value = parsedUserInfo.pseudoDaihyoCode;
          isAdmin.value = parsedUserInfo.isAdmin;
          daihyoCode.value = parsedUserInfo.daihyoCode;

          if (pseudoUserId.value == "") {
            // 疑似ログインIDが空の場合は、疑似ログインしていないとみなす
            serchUserId.value = userId.value;
            serchAgCode.value = agCode.value;
            serchDaihyoCode.value = daihyoCode.value;
          } else {
            outputDebugLogs("疑似ログイン状態");
            serchUserId.value = pseudoUserId.value;
            serchAgCode.value = pseudoAgCode.value;
            serchDaihyoCode.value = pseudoDaihyoCode.value;
          }

          outputDebugLogs("管理者フラグ：" + parsedUserInfo.isAdmin);
        }

        // 初期情報取得API
        const response = await apiAuthClient.post(
          "/api/ApplicationMgtKaunet/getInitialData",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
          }
        );

        // カテゴリリスト設定
        appCategoryList.value = response.data.categoryList;

        // ステータスリスト設定
        statusList.value = response.data.statusList;

        // AGコードリスト設定
        agCodeDataList.value = response.data.agCodeList;

        // 担当者リスト設定
        userList.value = response.data.userList;

        // ソート状態を保持
        appDataSortItemList.value = getSortItemListDef();

        // sessionStorageからパラメータ取得（申請画面から戻った場合に設定されている）
        const sessionParam = sessionStorage.getItem(
          AppConstants.APPLICATION_MGT_KAUNET_SESSION_NAME
        );
        if (sessionParam) {
          // 存在する場合はパラメータを変数にセット
          const appMgtParam = JSON.parse(sessionParam) as appMgtParam;
          // 検索条件を復元
          appSearchCond.value = appMgtParam.appSearchCond;
          processingMode.value = appMgtParam.processingMode;

          // 一覧に遷移前に検索結果が表示されていた場合は、検索する
          if (processingMode.value == AppConstants.PROCESSING_MODE_RESULT) {
            // 申請状況一覧データ取得
            await getApplicationData();

            // 一覧表示状態を復元
            currentPage.value = appMgtParam.currentPage;
            itemsPerPage.value = appMgtParam.itemsPerPage;
          } else {
            // 申請期間FROM
            appSearchCond.value.appDateFrom = formatDate(
              response.data.shinseiKikanStart
            );
            // 申請期間TO
            appSearchCond.value.appDateTo = formatDate(
              response.data.shinseiKikanEnd
            );
          }

          // sessionStorageからパラメータ削除
          sessionStorage.removeItem(
            AppConstants.APPLICATION_MGT_KAUNET_SESSION_NAME
          );
        } else {
          // 申請期間FROM
          appSearchCond.value.appDateFrom = formatDate(
            response.data.shinseiKikanStart
          );
          // 申請期間TO
          appSearchCond.value.appDateTo = formatDate(
            response.data.shinseiKikanEnd
          );
          // 検索条件入力モードを設定
          processingMode.value = AppConstants.PROCESSING_MODE_SERACH;
        }

        isInitError.value = false;
        isDataFetched.value = true; // データが取得されたことを設定
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    });

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, false);
    };

    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊
    // ページネーション関連
    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊

    /**
     * ページネーションのデータ生成
     */
    const paginatedData = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage.value;
      const end = start + itemsPerPage.value;
      return appDataList.value.slice(start, end);
    });

    /**
     * 頁総数を取得
     */
    const totalPages = computed(() => {
      return Math.ceil(appDataList.value.length / itemsPerPage.value);
    });

    /**
     * ページ切替ハンドラ
     */
    const handlePageChange = (page: number) => {
      currentPage.value = page;
    };

    /**
     * 表示件数変更
     * @param size 1ページに表示する件数
     */
    const changePageSize = (size: number) => {
      itemsPerPage.value = size;
      currentPage.value = 1;
    };

    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊
    // ボタン押下時処理関連 Start
    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊

    const getApplicationData = async () => {
      // キーワードをサニタイジング
      const sanitizedKeyWord = trimKeyword(
        sanitizeInput(appSearchCond.value.keyword, true)
      );
      // 対応担当者をサニタイジング
      const sanitizedOperater = trimKeyword(
        sanitizeInput(appSearchCond.value.operater, true)
      );
      // 営業担当者をサニタイジング
      const sanitizedkaunetUser = trimKeyword(
        sanitizeInput(appSearchCond.value.kaunetUser, true)
      );

      // 申請状況一覧取得API
      const response = await apiAuthClient.post(
        "/api/ApplicationMgtKaunet/GetApplicationList",
        {
          systemKbn: AppConstants.SYSTEM_KBN_WITH,
          userId: serchUserId.value,
          agCode: serchAgCode.value,
          daihyoCode: serchDaihyoCode.value,
          appDateFrom: appSearchCond.value.appDateFrom,
          appDateTo: appSearchCond.value.appDateTo,
          appType: appSearchCond.value.appType,
          status: appSearchCond.value.status,
          keyword: sanitizedKeyWord,
          wishDate: appSearchCond.value.wishDate,
          isDisableFinished: appSearchCond.value.disableFinised,
          targetAgCode: appSearchCond.value.agCode,
          operater: sanitizedOperater,
          kaunetUser: sanitizedkaunetUser,
        }
      );

      // レスポンスから申請状況リストを取得
      appDataList.value = response.data.appDataList;
    };

    /**
     * 検索ボタン押下
     */
    const onSearch = async () => {
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;

      // 申請一覧情報取得
      try {
        // メッセージクリア
        errorMessage.value = "";

        if (appSearchCond.value.appDateFrom == "") {
          errorMessage.value = formatMessage(messages.ERR_0001, "申請期間FROM");
          return;
        }

        if (appSearchCond.value.appDateTo == "") {
          errorMessage.value = formatMessage(messages.ERR_0001, "申請期間TO");
          return;
        }

        if (appSearchCond.value.appDateFrom && appSearchCond.value.appDateTo) {
          // 両方の値が入力されている場合、大小チェックを行う
          if (
            new Date(appSearchCond.value.appDateFrom) <=
            new Date(appSearchCond.value.appDateTo)
          ) {
            // チェックOK
          } else {
            errorMessage.value = formatMessage(
              messages.ERR_0005,
              "申請期間From",
              "申請期間To"
            );
            return;
          }
        }

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // 申請状況一覧データ取得
        await getApplicationData();

        // 先頭ページ表示
        currentPage.value = 1;

        // 検索結果表示モードを設定
        processingMode.value = AppConstants.PROCESSING_MODE_RESULT;
      } catch (error: unknown) {
        outputDebugLogs("エラー！！");
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          switch (axiosError.response.status) {
            case 416:
              // 検索件数オーバー
              errorMessage.value = formatMessage(
                messages.ERR_0023,
                "申請状況一覧検索"
              );
              break;
            default:
              // ほかのエラー
              errorMessage.value = messages.ERR_SYS999;
          }
        } else if (axiosError.request) {
          errorMessage.value = messages.ERR_SYS001;
        } else {
          errorMessage.value = messages.ERR_SYS002;
          if (process.env.VUE_APP_DEBUG === "true") {
            console.log("Error: ", axiosError.message);
          }
        }
      } finally {
        // スクロールを一番上に戻す
        scrollToTop();
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    };

    /**
     * 編集ボタン
     */
    const onEdit = async (applicationNo: string, isPreview = false) => {
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      // 申請一覧情報取得
      try {
        // メッセージクリア
        errorMessage.value = "";

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // プレビューモードではない場合、該当の申請情報が編集中かチェック
        if (!isPreview) {
          const response = await apiAuthClient.post(
            "/api/ApplicationMgtCommon/checkEditing",
            {
              systemKbn: AppConstants.SYSTEM_KBN_WITH,
              userId: serchUserId.value,
              agCode: serchAgCode.value,
              daihyoCode: serchDaihyoCode.value,
              applicationNo: applicationNo,
            }
          );

          if (response.data.checkResult) {
            // 編集中なら警告メッセージを表示
            const isConfirm = window.confirm(formatMessage(messages.CNF_0011));
            if (!isConfirm) {
              // いいえの場合
              return;
            }
          }
        }

        // sessionStorageに申請管理（受領側）のパラメータ保存
        sessionStorage.setItem(
          AppConstants.APPLICATION_MGT_KAUNET_SESSION_NAME,
          JSON.stringify({
            agCode: serchAgCode.value,
            userId: serchUserId.value,
            daihyoCode: serchDaihyoCode.value,
            applicationNo: applicationNo,
            processingMode: isPreview
              ? AppConstants.EDIT_MODE_PREVIEW
              : AppConstants.EDIT_MODE_UPDATE,
            appSearchCond: appSearchCond.value,
            itemsPerPage: itemsPerPage.value,
            currentPage: currentPage.value,
            listProcessingMode: processingMode.value,
          })
        );

        // 申請管理（受領側）へ更新モードで遷移
        router.push({
          path: "/shinseiform-kaunet",
        });
      } finally {
        processingStore.isProcessing = false;
      }
    };

    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊
    // ボタン押下時処理関連 End
    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊

    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊
    // ソート関連 Start
    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊
    /**
     * 検索結果のソート処理を行います。
     * @param key ソート項目
     */
    const onSortItem = (key: string) => {
      appDataSortItemList.value.forEach((sortItem) => {
        if (sortItem.key == key) {
          switch (sortItem.key) {
            case "shinseiNo":
              if (
                sortItem.direction == ApplicationListConstants.SORT_TYPE_ASC
              ) {
                // 降順
                appDataList.value.sort((a, b) =>
                  b.applicationNo.localeCompare(a.applicationNo)
                );
              } else {
                // 昇順
                appDataList.value.sort((a, b) =>
                  a.applicationNo.localeCompare(b.applicationNo)
                );
              }
              break;
            case "shinseiDate":
              if (
                sortItem.direction == ApplicationListConstants.SORT_TYPE_ASC
              ) {
                // 降順
                appDataList.value.sort((a, b) =>
                  b.applicationDate.localeCompare(a.applicationDate)
                );
              } else {
                // 昇順
                appDataList.value.sort((a, b) =>
                  a.applicationDate.localeCompare(b.applicationDate)
                );
              }
              break;
            case "shinseiCategory":
              if (
                sortItem.direction == ApplicationListConstants.SORT_TYPE_ASC
              ) {
                // 降順
                appDataList.value.sort((a, b) =>
                  b.applicationCategoryId.localeCompare(a.applicationCategoryId)
                );
              } else {
                // 昇順
                appDataList.value.sort((a, b) =>
                  a.applicationCategoryId.localeCompare(b.applicationCategoryId)
                );
              }
              break;
            case "shinseiStatus":
              if (
                sortItem.direction == ApplicationListConstants.SORT_TYPE_ASC
              ) {
                // 降順
                appDataList.value.sort((a, b) =>
                  b.statusKbn.localeCompare(a.statusKbn)
                );
              } else {
                // 昇順
                appDataList.value.sort((a, b) =>
                  a.statusKbn.localeCompare(b.statusKbn)
                );
              }
              break;
            case "wishDate":
              if (
                sortItem.direction == ApplicationListConstants.SORT_TYPE_ASC
              ) {
                // 降順
                appDataList.value.sort((a, b) =>
                  b.wishDate.localeCompare(a.wishDate)
                );
              } else {
                // 昇順
                appDataList.value.sort((a, b) =>
                  a.wishDate.localeCompare(b.wishDate)
                );
              }
              break;
            case "lastUpdate":
              if (
                sortItem.direction == ApplicationListConstants.SORT_TYPE_ASC
              ) {
                // 降順
                appDataList.value.sort((a, b) =>
                  b.lastUpdDate.localeCompare(a.lastUpdDate)
                );
              } else {
                // 昇順
                appDataList.value.sort((a, b) =>
                  a.lastUpdDate.localeCompare(b.lastUpdDate)
                );
              }
              break;
            case "agCode":
              if (
                sortItem.direction == ApplicationListConstants.SORT_TYPE_ASC
              ) {
                // 降順
                appDataList.value.sort((a, b) =>
                  b.appAgCode.localeCompare(a.appAgCode)
                );
              } else {
                // 昇順
                appDataList.value.sort((a, b) =>
                  a.appAgCode.localeCompare(b.appAgCode)
                );
              }
              break;
          }

          if (sortItem.direction == ApplicationListConstants.SORT_TYPE_ASC) {
            sortItem.direction = ApplicationListConstants.SORT_TYPE_DESC;
          } else {
            sortItem.direction = ApplicationListConstants.SORT_TYPE_ASC;
          }
        }
      });
    };

    /**
     * ソート項目の初期値を返却します。
     */
    const getSortItemListDef = () => {
      return [
        {
          key: "shinseiNo",
          direction: ApplicationListConstants.SORT_TYPE_ASC,
        },
        {
          key: "shinseiDate",
          direction: ApplicationListConstants.SORT_TYPE_DESC,
        },
        {
          key: "shinseiCategory",
          direction: ApplicationListConstants.SORT_TYPE_ASC,
        },
        {
          key: "shinseiStatus",
          direction: ApplicationListConstants.SORT_TYPE_ASC,
        },
        {
          key: "wishDate",
          direction: ApplicationListConstants.SORT_TYPE_DESC,
        },
        {
          key: "lastUpdate",
          direction: ApplicationListConstants.SORT_TYPE_DESC,
        },
        {
          key: "agCode",
          direction: ApplicationListConstants.SORT_TYPE_DESC,
        },
      ];
    };

    /**
     * ソート順が昇順か判定します。
     * @param key ソート項目
     */
    const isDirectionASC = (key: string): boolean => {
      const sortItem = appDataSortItemList.value.find(
        (sortItem) => sortItem.key == key
      );
      if (
        sortItem &&
        sortItem.direction == ApplicationListConstants.SORT_TYPE_ASC
      ) {
        return true;
      }
      return false;
    };

    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊
    // ソート関連 End
    // ＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊＊

    return {
      isInitError,
      isDataFetched,
      errorMessage,
      currentPage,
      itemsPerPage,
      isSearchMode,
      appDataList,
      paginatedData,
      totalPages,
      handlePageChange,
      AppConstants,
      appSearchCond,
      appCategoryList,
      statusList,
      agCodeDataList,
      userList,
      onSearch,
      dispNums,
      isDirectionASC,
      onSortItem,
      changePageSize,
      isAdmin,
      isLoading,
      onEdit,
    };
  },
});
</script>
<style scoped>
td {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 0;
}

.col_btnUpdate {
  width: 4.8%;
}
.col_SinseiNo {
  width: 7.8%;
}
.col_SinseiDate {
  width: 6.3%;
}
.col_SinseiUser {
  width: 5.9%;
}
.col_SinseiCategory {
  width: 12.9%;
}
.col_SinseiTitle {
  width: 20%;
}
.col_SinseiStatus {
  width: 6.9%;
}
.col_WishDate {
  width: 6.5%;
}
.col_LastUpdate {
  width: 6.7%;
}
.col_Operater {
  width: 4.8%;
}
.col_KaunetUser {
  width: 4.8%;
}
.col_AgCode {
  width: 6.5%;
}
.col_AGName {
  width: 6%;
}

.sortable {
  cursor: pointer;
  position: relative;
  padding-right: 20px;
}
.sortable::after {
  content: "";
  position: absolute;
  right: 5px;
}
.sortable.asc::after {
  border: solid #000;
  border-width: 0 1.5px 1.5px 0;
  display: inline-block;
  height: 8px;
  position: relative;
  transition: 0.2s;
  margin: 0.1em 0 0 0.6em;
  transform: rotate(-135deg);
  vertical-align: middle;
  width: 8px;
}
.sortable.desc::after {
  border: solid #000;
  border-width: 0 1.5px 1.5px 0;
  display: inline-block;
  height: 8px;
  position: relative;
  transition: 0.2s;
  margin: -0.5em 0 0 0.6em;
  transform: rotate(45deg);
  vertical-align: middle;
  width: 8px;
}
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
.flex-container {
  display: flex;
  justify-content: space-between;
}
.btn {
  margin: 0.25rem 0.125rem;
}
.btn-footer {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 140px;
}
.btn-large {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 150px;
}
.table > :not(caption) > * > * {
  padding: 0rem 0.2rem;
}
thead {
  text-align: center;
  vertical-align: middle;
}
.thead-light {
  background-color: lightgray;
}
tbody {
  vertical-align: middle;
}
.form-control-title {
  text-align: right;
}
.form-control-center {
  text-align: center;
}
select.form-control {
  -webkit-appearance: auto;
  appearance: auto;
}
.form-check-input {
  margin-bottom: 0.3rem;
  margin-right: 0.4rem;
  margin-left: 0.7rem;
  vertical-align: inherit;
}

/* ヘッダー全体を左右に分割 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1em;
}

/* 表示件数のリンク部分を枠で囲む */
.page-size-selector {
  display: flex;
  align-items: center;
  padding: 0.5em;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* 「表示件数」テキストのマージン調整 */
.page-size-selector span:first-of-type {
  margin-right: 0.5em;
}

/* リンクのスタイル */
.page-size-selector a {
  cursor: pointer;
  text-decoration: none;
  color: black;
  margin: 0 0.25em;
}

/* 選択中のリンクに強調表示 */
.page-size-selector a.active {
  font-weight: bold;
  text-decoration: underline;
}

.ellipsis-label {
  display: inline-block; /* 横幅を指定するために必要 */
  width: 85%; /* 必要な幅に調整してください */
  white-space: nowrap; /* 改行をさせない */
  overflow: hidden; /* はみ出したテキストを非表示 */
  text-overflow: ellipsis; /* はみ出した部分を3点リーダーで省略 */
  vertical-align: middle;
}

.ellipsis-link {
  display: inline-block; /* 幅を固定して省略を有効にする */
  width: 85%; /* 必要に応じて調整 */
  white-space: nowrap; /* 改行させない */
  overflow: hidden; /* はみ出した部分を隠す */
  text-overflow: ellipsis; /* 末尾を「…」で省略 */
  vertical-align: middle; /* 行内要素の中央揃え */

  /* ここからリンク風の装飾 */
  color: #0066cc; /* ブラウザ標準のリンク色に近いブルー */
  text-decoration: underline; /* 下線を引く */
  cursor: pointer; /* マウスオーバー時に手のアイコンに */
}

.com_icon_new_app {
  display: inline-block; /* 明示的にinline-blockにする */
  vertical-align: middle;
  color: #ff3540;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-align: center;
}
.ellipsis-label + .com_icon_new_app {
  margin-left: 7px;
}

.ellipsis-link + .com_icon_new_app {
  margin-left: 7px;
}

.page-size-selector a.disabled {
  pointer-events: none; /* マウスイベントを無効化 */
  opacity: 0.4; /* 半透明で無効感を演出 */
  cursor: not-allowed; /* 禁止カーソルに */
}
</style>
